// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_PaginasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /config/traducoes/paginas. */
import type { Traducoes_PaginaRow } from './Traducoes_PaginaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_PaginasResponseDados {
paginas: Traducoes_PaginaRow[]
}

export type Traducoes_PaginasResponse = ApiResponse<Traducoes_PaginasResponseDados>;

registerResponseContract('Traducoes_PaginasResponse', {
  paginas: {
    type: 'array',
    required: true,
    items: {
      id:   { type: 'number',  required: false },
      nome: { type: 'string',  required: false },
    },
  },
})
